<ng-container
  (clickOutside)="onClose()"
  [delayClickOutsideInit]="true"
  [clickOutsideExclude]="'.sidebar__item-right, .project-menu__project-form, .project-menu__list'"
>
  <div class="project-menu__list">
    <div class="project-menu__item" (click)="onOpenEditForm($event)">
      <div class="project-menu__icon">
        <svg
          width="14px"
          height="15px"
          viewBox="0 0 14 15"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Assets"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            transform="translate(-986.000000, -61.000000)"
          >
            <g id="Edit" transform="translate(986.000000, 61.000000)" fill="#B3BFC9">
              <path
                d="M13.3280488,13.5621951 L0.768292683,13.5621951 C0.464634146,13.5621951 0.219512195,13.8073171 0.219512195,14.1109756 C0.219512195,14.4146341 0.464634146,14.6597561 0.768292683,14.6597561 L13.3280488,14.6597561 C13.6317073,14.6597561 13.8768293,14.4146341 13.8768293,14.1109756 C13.8768293,13.8073171 13.6317073,13.5621951 13.3280488,13.5621951 M1.34634146,9.24512195 L7.44878049,3.12073171 L9.01463415,4.6902439 L2.90487805,10.8036585 L1.34634146,10.8036585 L1.34634146,9.24512195 Z M9.12073171,1.44146341 L10.6939024,3.01463415 L9.79390244,3.91463415 L8.22439024,2.34512195 L9.12073171,1.44146341 Z M0.797560976,11.9012195 L3.13170732,11.9012195 C3.27804878,11.9012195 3.41707317,11.8426829 3.5195122,11.7402439 L11.8573171,3.40243902 C11.9597561,3.3 12.0182927,3.15731707 12.0182927,3.01463415 C12.0182927,2.86829268 11.9597561,2.72926829 11.8573171,2.62682927 L9.50853659,0.27804878 C9.40609756,0.175609756 9.26707317,0.117073171 9.12073171,0.117073171 C8.97439024,0.117073171 8.83536585,0.175609756 8.73292683,0.27804878 L0.409756098,8.6304878 C0.307317073,8.73658537 0.248780488,8.87560976 0.248780488,9.01829268 L0.248780488,11.352439 C0.248780488,11.6560976 0.493902439,11.9012195 0.797560976,11.9012195 Z"
                id="7H"
              ></path>
            </g>
          </g>
        </svg>
      </div>
      <div class="project-menu__right">
        <div class="project-menu__text">Редактировать</div>
        <div class="project-menu__arrow"></div>
      </div>
    </div>

    <div class="project-menu__item" (click)="onOpenCreateSubProjectForm($event)">
      <div class="project-menu__icon">
        <svg
          width="14px"
          height="15px"
          viewBox="0 0 14 15"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="Assets" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="FolderPlus" fill="#B3BFC9">
              <path
                d="M12.5,3 L7.2,3 L5.7,1.5 L1.5,1.5 C0.67157288,1.5 0,2.17157288 0,3 L0,11.5 C0,12.3284271 0.67157288,13 1.5,13 L12.5,13 C13.3284271,13 14,12.3284271 14,11.5 L14,4.5 C14,3.67157288 13.3284271,3 12.5,3 Z M12.5,12 L1.5,12 C1.22385763,12 1,11.7761424 1,11.5 L1,3 C1,2.72385763 1.22385763,2.5 1.5,2.5 L5.3,2.5 L6.8,4 L12.5,4 C12.7761424,4 13,4.22385763 13,4.5 L13,11.5 C13,11.7761424 12.7761424,12 12.5,12 Z M7.5,5.5 L6.5,5.5 L6.5,7.25 L4.75,7.25 L4.75,8.25 L6.5,8.25 L6.5,10 L7.5,10 L7.5,8.25 L9.25,8.25 L9.25,7.25 L7.5,7.25 L7.5,5.5 Z"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="project-menu__right">
        <div class="project-menu__text">Добавить подпроект</div>
        <div class="project-menu__arrow"></div>
      </div>
    </div>

    @if (model(); as currentModel) {
      @if (!currentModel.isArchive) {
        <div class="project-menu__item" (click)="onDelete()">
          <div class="project-menu__icon">
            <svg
              width="12px"
              height="15px"
              viewBox="0 0 12 15"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Assets"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(-987.000000, -170.000000)"
              >
                <g id="Trash" transform="translate(987.000000, 170.000000)" fill="#B3BFC9" fill-rule="nonzero">
                  <path
                    d="M12,2.25 L7.83,2.25 L7.83,1.84 C7.7330777,0.92434994 6.96076542,0.229472953 6.04,0.229472953 C5.11923458,0.229472953 4.3469223,0.92434994 4.25,1.84 L4.25,2.25 L0,2.25 L0,3.25 L1.08,3.25 L1.92,13.33 C1.96179703,13.8508219 2.39750629,14.2516745 2.92,14.25 L9.08,14.25 C9.60249371,14.2516745 10.038203,13.8508219 10.08,13.33 L10.92,3.25 L12,3.25 L12,2.25 Z M9.08,13.25 L2.92,13.25 L2.09,3.25 L9.91,3.25 L9.08,13.25 Z M5.21,2 C5.27196803,1.61176361 5.60684923,1.3260952 6,1.3260952 C6.39315077,1.3260952 6.72803197,1.61176361 6.79,2 L6.79,2.3 L5.17,2.3 L5.21,2 Z"
                    id="Shape"
                  ></path>
                  <rect id="Rectangle-path" x="4" y="5.25" width="1" height="6"></rect>
                  <rect id="Rectangle-path" x="7" y="5.25" width="1" height="6"></rect>
                </g>
              </g>
            </svg>
          </div>
          <div class="project-menu__right project-menu__right_no-border">
            <div class="project-menu__text project-menu__text_red">
              {{ statusDeleteConfirm() === 0 ? 'Архивировать' : 'Вы уверены?' }}
            </div>
            <div class="project-menu__arrow"></div>
          </div>
        </div>
      } @else {
        <div class="project-menu__item" (click)="onRestore()">
          <div class="project-menu__icon">
            <svg
              width="12px"
              height="15px"
              viewBox="0 0 12 15"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Assets"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(-987.000000, -170.000000)"
              >
                <g id="Trash" transform="translate(987.000000, 170.000000)" fill="#B3BFC9" fill-rule="nonzero">
                  <path
                    d="M12,2.25 L7.83,2.25 L7.83,1.84 C7.7330777,0.92434994 6.96076542,0.229472953 6.04,0.229472953 C5.11923458,0.229472953 4.3469223,0.92434994 4.25,1.84 L4.25,2.25 L0,2.25 L0,3.25 L1.08,3.25 L1.92,13.33 C1.96179703,13.8508219 2.39750629,14.2516745 2.92,14.25 L9.08,14.25 C9.60249371,14.2516745 10.038203,13.8508219 10.08,13.33 L10.92,3.25 L12,3.25 L12,2.25 Z M9.08,13.25 L2.92,13.25 L2.09,3.25 L9.91,3.25 L9.08,13.25 Z M5.21,2 C5.27196803,1.61176361 5.60684923,1.3260952 6,1.3260952 C6.39315077,1.3260952 6.72803197,1.61176361 6.79,2 L6.79,2.3 L5.17,2.3 L5.21,2 Z"
                    id="Shape"
                  ></path>
                  <rect id="Rectangle-path" x="4" y="5.25" width="1" height="6"></rect>
                  <rect id="Rectangle-path" x="7" y="5.25" width="1" height="6"></rect>
                </g>
              </g>
            </svg>
          </div>
          <div class="project-menu__right project-menu__right_no-border">
            <div class="project-menu__text project-menu__text_red">Восстановить из архива</div>
            <div class="project-menu__arrow"></div>
          </div>
        </div>
      }
    }
  </div>
</ng-container>
